module.exports = __webpack_public_path__ + "img/crayons.c06013c1.jpeg";